export function CanvasTabs({ tabs, tab, setTab }) {
  return (
    <div className="px-6 pt-3 pb-2 border-b border-slate-200/80 bg-white/70 backdrop-blur-sm overflow-x-auto thin-scroll">
      <div className="inline-flex gap-1 p-1 rounded-xl bg-slate-100/80 ring-1 ring-slate-200/60">
        {tabs.map(([key, label, count]) => (
          <button key={key} data-testid={`canvas-tab-${key}`} onClick={() => setTab(key)}
            className={`whitespace-nowrap px-3.5 py-1.5 text-xs font-semibold rounded-lg ${tab === key ? "bg-white text-slate-900 shadow-[0_1px_3px_rgba(15,23,42,0.12)]" : "text-slate-500 hover:text-slate-800"}`}>
            {label}{count != null && <span className={`ml-1.5 num text-[10px] px-1.5 py-px rounded-full ${tab === key ? "bg-sky-100 text-sky-700" : "bg-slate-200/70 text-slate-500"}`}>{count}</span>}
          </button>
        ))}
      </div>
    </div>
  );
}
